import { Injectable } from '@angular/core';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { WindowService } from '../../../../../common/angular-shared/services/window/window.service';
import { Controller } from '../../../js/Controller';
import { BaseLoginService } from '../../../../../coverpath-common/angular/services/login/base-login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginType } from '../../../../../coverpath-common/angular/classes/LoginType';

@Injectable()
export class LoginService extends BaseLoginService {
  controller: Controller;

  constructor(
    protected windowService: WindowService,
    protected route: ActivatedRoute,
    protected router: Router,
    private amorphicServiceInject: AmorphicService
  ) {
    super(windowService, route, router, amorphicServiceInject);
  }

  protected getController(): Controller {
    return this.windowService.nativeWindow.controller;
  }

  public async needTFACheck(): Promise<boolean> {
    return this.controller.checkTFARequired();
  }

  public async login(loginType?: LoginType): Promise<void> {
    await this.controller.login(loginType);
  }
}
